module.exports = __webpack_public_path__ + "media/images/driving_school/results_series-188c875d78a892d986eb5653d8b3befb.png";